'use client';
import { TableSortProvider } from '@/components/context/tableProvider';
import { TableTbody } from '@/components/ui/data-display/tables/TableTbody';
import { TableThead } from '@/components/ui/data-display/tables/TableThead';
import { TableTr } from '@/components/ui/data-display/tables/TableTr';

import { Table } from '@/components/ui/data-display/tables/Table';
import { useState } from 'react';
import { getCellValueFromGroup } from 'utils/getCellValueFromGroup';
import { groupRowsByRowspan } from 'utils/groupRowByRowSpan';
import { parseCustomDate } from 'utils/parseCustomDate';
import { Instances } from '../Instances';

export const TableBlock = ({ data }) => {
  const [sortBy, setSortBy] = useState(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);

  const handleSort = (fieldKey) => {
    const reversed = fieldKey === sortBy ? !reverseSortDirection : false;
    setSortBy(fieldKey);
    setReverseSortDirection(reversed);
  };

  const headingTitles =
    data?.relations?.TableHeadingList?.map((h) => h.fields?.title) || [];

  const sortIndex = headingTitles.indexOf(sortBy);

  const isDate = (value) => !Number.isNaN(parseCustomDate(value));

  const rows = [...(data?.relations?.TableRowsList || [])];

  const groups = groupRowsByRowspan(rows);

  if (sortIndex !== -1) {
    groups.sort((a, b) => {
      const aCell = getCellValueFromGroup(a, sortIndex) ?? '';
      const bCell = getCellValueFromGroup(b, sortIndex) ?? '';

      if (isDate(aCell) && isDate(bCell)) {
        const aDate = parseCustomDate(aCell);
        const bDate = parseCustomDate(bCell);
        return reverseSortDirection ? bDate - aDate : aDate - bDate;
      }

      return reverseSortDirection
        ? String(bCell).localeCompare(String(aCell))
        : String(aCell).localeCompare(String(bCell));
    });
  }

  let fallbackCounter = 0;

  return (
    <TableSortProvider
      value={{ sortBy, reverseSortDirection, setSorting: handleSort }}
    >
      <Table data={data}>
        {data?.relations?.TableHeadingList?.length > 0 && (
          <TableThead>
            <TableTr>
              <Instances instances={data?.relations?.TableHeadingList} />
            </TableTr>
          </TableThead>
        )}
        {groups.map((group) => {
          const keyParts = (group || []).map(
            (row) => row?.meta?.id ?? row?.meta?.key ?? '',
          );
          const key =
            keyParts.filter(Boolean).join('-') ||
            `group-fallback-${fallbackCounter++}`;

          return (
            <TableTbody key={key}>
              <Instances instances={group} />
            </TableTbody>
          );
        })}
      </Table>
    </TableSortProvider>
  );
};
